import { render, staticRenderFns } from "./AddBankAccountBlock.vue?vue&type=template&id=5fff52eb&"
import script from "./AddBankAccountBlock.vue?vue&type=script&lang=ts&"
export * from "./AddBankAccountBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports